import { IServerPagination } from "app/model"
import { getStore } from "app/store/store"
import { IOrderList, IOrderRefreshListParams } from "order/model"
import { orderRPO } from "order/repository"
import { orderActionCreator } from "order/store/actions"

export async function refreshOrderList(params: IOrderRefreshListParams): Promise<void> {
  let { pagination, filters } = params
  const list = getStore().getState().advertiser.list
  getStore().dispatch(orderActionCreator.setList({ isRefreshing: true, hasRefreshError: false }))
  if (!pagination) {
    pagination = list.pagination
  }
  let rowCount: number = list.rowCount
  if (!filters) {
    filters = list.filters
  }
  try {
    rowCount = await orderRPO.getOrdersCount(filters)
  } catch (error) {
    console.error(error)
    getStore().dispatch(
      orderActionCreator.setList({
        isRefreshing: false,
        hasRefreshError: true,
        filteredOrders: []
      })
    )
    return
  }
  try {
    const newList: Partial<IOrderList> = {
      isRefreshing: false,
      hasRefreshError: false,
      rowCount
    }
    if (params.pagination) {
      newList.pagination = pagination
    } else {
      newList.pagination = list.pagination
    }
    if (rowCount < newList.pagination.page * newList.pagination.pageSize) {
      newList.pagination.page = 0
    }
    if (params.filters) {
      newList.filters = params.filters
    }
    newList.filteredOrders = await orderRPO.getOrders(newList.pagination || pagination, newList.filters || filters)
    getStore().dispatch(orderActionCreator.setList(newList))
  } catch (error) {
    console.error(error)
    getStore().dispatch(orderActionCreator.setList({ isRefreshing: false, hasRefreshError: true, filteredOrders: [] }))
  }
}

export function getDefaultOrderPagination(): IServerPagination {
  return {
    pageSize: 10,
    page: 0,
    orderBy: "name",
    order: "asc"
  }
}
